

export interface IValidateEffectiveDateRequest {
    orgVehicleTypeMapId: number;
    rateType: number;
    userId: number;
    orgId: number;
    effectiveFrom: string;

}


export class ValidateEffectiveDateRequest implements IValidateEffectiveDateRequest {
    orgVehicleTypeMapId: number;
    rateType: number;
    userId: number;
    orgId: number;
    effectiveFrom: string;
    constructor(orgVehicleTypeMapId: number, effectiveFrom: string) {
        this.orgVehicleTypeMapId = orgVehicleTypeMapId;
        this.effectiveFrom = effectiveFrom;
    }
} 
